import { render, staticRenderFns } from "./VolanTextarea.vue?vue&type=template&id=3df1d670"
import script from "./VolanTextarea.vue?vue&type=script&lang=js"
export * from "./VolanTextarea.vue?vue&type=script&lang=js"
import style0 from "./VolanTextarea.vue?vue&type=style&index=0&id=3df1d670&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.43_babel-core@6.26.3_css-loader@6.11.0_webpack_53a2985e0d5a2f62f061ee97dc298f7f/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports